import React from 'react'
import PropTypes from 'prop-types'
import {
  PropertyInfo,
  // ListingCardIndicator as AuctionInfo,
  ListingCardIndicator,
  // LeftSidePropertyValue as PropertyValue,
  LeftSidePropertyValue,
  linkPropType,
  listingPropType,
} from '../listingCard/cardParts'
import { getAddressLine } from '../listingCard/cardHelpers'
import classnames from 'classnames/bind'
import cls from './styles.scss'
const cx = classnames.bind(cls)

const PopupAddress = ({ address, elmId }) => {
  return (
    <div
      data-elm-id={`${elmId}_address_field`}
      className={cx('address-field', 'nowrap')}
    >
      {address}
    </div>
  )
}

PopupAddress.propTypes = {
  address: PropTypes.string,
  elmId: PropTypes.string,
}

const CardImage = ({
  listing,
  listingPhotoUrl,
  defaultPhotoUrl,
  className,
}) => {
  const altTextImage = getAddressLine(listing.seller_property)

  return (
    <div
      className={cx('property-card-image-container', className)}
      style={{
        backgroundImage: `url(${defaultPhotoUrl})`,
      }}
    >
      <div
        className={cx('property-card-image-background')}
        style={{
          backgroundImage: `url(${listingPhotoUrl})`,
        }}
        role='img'
        aria-label={altTextImage}
      />
    </div>
  )
}

CardImage.propTypes = {
  listing: listingPropType,
  listingPhotoUrl: PropTypes.string,
  defaultPhotoUrl: PropTypes.string,
  className: PropTypes.string,
}

export {
  PopupAddress,
  CardImage,
  // PropertyValue,
  LeftSidePropertyValue as PropertyValue,
  PropertyInfo,
  // AuctionInfo
  ListingCardIndicator as AuctionInfo,
  linkPropType,
}
